import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcTeam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 13a4 4 0 0 1 3.127 6.495c2.464.9 3.797 3.017 3.87 6.223L16 26h-2c0-3.448-1.552-5-5-5-3.362 0-4.921 1.476-4.997 4.745L4 26H2c0-3.365 1.337-5.58 3.873-6.506A4 4 0 0 1 9 13Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM23 4a4 4 0 0 1 3.127 6.495c2.464.9 3.797 3.017 3.87 6.223L30 17h-2c0-3.448-1.552-5-5-5-3.362 0-4.921 1.476-4.997 4.745L18 17h-2c0-3.365 1.337-5.58 3.873-6.506A4 4 0 0 1 23 4Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
export default SvgIcTeam;
